unit uLoadTXT;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Controls, WEBLib.ExtCtrls, Vcl.Imaging.pngimage, WEBLib.Controls, WEBLib.Dialogs,
  WEBLib.SyntaxMemo, WEBLib.WebCtrls, Web, JS, libfilereader, WEBLib.Buttons,
  WEBLib.REST, WEBLib.Grids, WEBLib.DBCtrls, Data.DB, WEBLib.DB, WEBLib.CDS, WebLib.JSON;

type
  TLoadTXT = class(TForm)
    Datas_Con: TClientConnection;
    divTabela: THTMLDiv;       //Tabela das Datas
    divTabelaEtqs: THTMLDiv;
    btnImprimir: TButton;
    Msg01: TMessageDlg;
    Datas_DSET: TClientDataSet;
    Cargas_idudv: TIntegerField;
    Cargas_DataMvto: TDateTimeField;
    Cargas_QtdeUD: TIntegerField;
    btnPROC: TButton;
    execAPIs: THttpRequest;
    btnLoadFILE: TFilePicker;
    nRESP: TMemo;
    nArq: TMemo;
    UDs_Con: TClientConnection;
    UDs_DSET: TClientDataSet;
    UDs_IdProd: TIntegerField;
    UDs_produto: TStringField;
    UDs_Descr: TStringField;
    UDs_IdUd: TIntegerField;

    procedure Datas_ConAfterConnect(Sender: TObject);
    procedure btnImprimirClick(Sender: TObject);
    [async] procedure btnPROCClick(Sender: TObject); async;
    procedure btnLoadFILEChange(Sender: TObject);
    procedure btnLoadFILEGetFileAsText(Sender: TObject; AFileIndex: Integer;
      AText: string);
    procedure loadTXTChange(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    [async]
    procedure IdCardDblClick(Sender: TObject); async;
    procedure UDs_ConAfterConnect(Sender: TObject);
  private
    { Private declarations }
public
    { Public declarations }
    frm: TForm;

    cItens, JSok: integer;
    vItens
    : string;

    qCards,
    xIdUdV             //Identificador da Tabela ItensNF_Volumes
    : integer;

    fl: Boolean;
    fr: TFileReader;
    FFileName: string;

    procedure Zap_API_Data(Id: Integer);  //Exclui UDs e livra as mesmas da Data
    procedure Load_API_Datas;
    procedure Load_API_UDs(Id: Integer);  //Listagem das UDs somadas por Produto
    procedure LoadTable_Datas;            //Gera HTML das Datas de leitura dos arquivos
    procedure LoadTable_UDS;              //Gera HTML das UDs somadas por Produto
    procedure LoadFile;                   //Carrega Arquivo no Memo

    //A lista das Datas tem Limite de 6 Linhas (Se for mais então não haverá Eventos para os demais)
    function HandleEdit0Click(Event: TJSMouseEvent): Boolean;
    function HandleEdit1Click(Event: TJSMouseEvent): Boolean;
    function HandleEdit2Click(Event: TJSMouseEvent): Boolean;
    function HandleEdit3Click(Event: TJSMouseEvent): Boolean;
    function HandleEdit4Click(Event: TJSMouseEvent): Boolean;
    function HandleEdit5Click(Event: TJSMouseEvent): Boolean;

    //Eventos de Exclusão criados no HTML via runtime
    function HandleZap0Click(Event: TJSMouseEvent): Boolean;
    function HandleZap1Click(Event: TJSMouseEvent): Boolean;
    function HandleZap2Click(Event: TJSMouseEvent): Boolean;
    function HandleZap3Click(Event: TJSMouseEvent): Boolean;
    function HandleZap4Click(Event: TJSMouseEvent): Boolean;
    function HandleZap5Click(Event: TJSMouseEvent): Boolean;

  protected procedure LoadDFMValues; override; end;

var
  LoadTXT: TLoadTXT;

implementation

{$R *.dfm}

uses
  uFrmMain, uCards;

function TLoadTXT.HandleEdit0Click(Event: TJSMouseEvent): Boolean;
var
  el: TJSElement;
begin
  // set sidebar element active style
  el := document.getElementById('leitura0');
  //el['class'] := 'active';
  //ShowMessage('Etiquetas Nº: ' + el['value'] + ' pesquisadas !');

  //Coloca Identificador da Tabela na variável global
  if el['value'] <> '' then
  begin
    xIdUdV:= StrToInt(el['value']);
    Load_API_UDs(StrToInt(el['value'])); //Pesquisa Itens da Data
  end;

  Result := true;
  Event.preventDefault;
  Event.stopPropagation;
end;

function TLoadTXT.HandleEdit1Click(Event: TJSMouseEvent): Boolean;
//begin
//  showmessage('hello world');
var
  el: TJSElement;
begin
  // set sidebar element active style
  el := document.getElementById('leitura1');
  //el['class'] := 'active';
  //ShowMessage('View da Data Nº ' + el['value'] + ' pesquisadas !');

  //Coloca Identificador da Tabela na variável global
  if el['value'] <> '' then
  begin
    xIdUdV:= StrToInt(el['value']);
    Load_API_UDs(StrToInt(el['value'])); //Pesquisa Itens da Data
  end;

  Result := false;
  Event.preventDefault;
  Event.stopPropagation;
end;

function TLoadTXT.HandleEdit2Click(Event: TJSMouseEvent): Boolean;
//begin
//  showmessage('hello world');
var
  el: TJSElement;
begin
  // set sidebar element active style
  el := document.getElementById('leitura2');
  //el['class'] := 'active';
  //ShowMessage('View da Data Nº ' + el['value'] + ' pesquisadas !');

  //Coloca Identificador da Tabela na variável global
  if el['value'] <> '' then
  begin
    xIdUdV:= StrToInt(el['value']);
    Load_API_UDs(StrToInt(el['value'])); //Pesquisa Itens da Data
  end;

  Result := false;
  Event.preventDefault;
  Event.stopPropagation;

end;

function TLoadTXT.HandleEdit3Click(Event: TJSMouseEvent): Boolean;
var
  el: TJSElement;
begin
  // set sidebar element active style
  el := document.getElementById('leitura3');
  //el['class'] := 'active';
  //ShowMessage('View da Data Nº ' + el['value'] + ' pesquisadas !');

  //Coloca Identificador da Tabela na variável global
  if el['value'] <> '' then
  begin
    xIdUdV:= StrToInt(el['value']);
    Load_API_UDs(StrToInt(el['value'])); //Pesquisa Itens da Data
  end;

  Result := false;
  Event.preventDefault;
  Event.stopPropagation;
end;

function TLoadTXT.HandleEdit4Click(Event: TJSMouseEvent): Boolean;
var
  el: TJSElement;
begin
  // set sidebar element active style
  el := document.getElementById('leitura4');
  //el['class'] := 'active';
  //ShowMessage('View da Data Nº ' + el['value'] + ' pesquisadas !');

  //Coloca Identificador da Tabela na variável global
  if el['value'] <> '' then
  begin
    xIdUdV:= StrToInt(el['value']);
    Load_API_UDs(StrToInt(el['value'])); //Pesquisa Itens da Data
  end;

  Result := false;
  Event.preventDefault;
  Event.stopPropagation;
end;

function TLoadTXT.HandleEdit5Click(Event: TJSMouseEvent): Boolean;
var
  el: TJSElement;
begin
  // set sidebar element active style
  el := document.getElementById('leitura5');
  //el['class'] := 'active';
  //ShowMessage('View da Data Nº ' + el['value'] + ' pesquisadas !');

  //Coloca Identificador da Tabela na variável global
  if el['value'] <> '' then
  begin
    xIdUdV:= StrToInt(el['value']);
    Load_API_UDs(StrToInt(el['value'])); //Pesquisa Itens da Data
  end;

  Result := false;
  Event.preventDefault;
  Event.stopPropagation;
end;

function TLoadTXT.HandleZap0Click(Event: TJSMouseEvent): Boolean;

    procedure Afterdialog(Value: TModalResult);
    var
      el: TJSElement;
    begin

          if Value = mrYes then
          begin

              // set sidebar element active style
              el := document.getElementById('leitura0');

              //Coloca Identificador da Tabela na variável global
              if el['value'] <> '' then
              begin
                  Zap_API_Data(StrToInt(el['value'])); //Pesquisa Itens da Data
              end;

              Result := true;
              Event.preventDefault;
              Event.stopPropagation;

          end;

    end;

begin
  Msg01.ShowDialog('Deseja excluir a data selecionada ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

function TLoadTXT.HandleZap1Click(Event: TJSMouseEvent): Boolean;

    procedure Afterdialog(Value: TModalResult);
    var
      el: TJSElement;
    begin

          if Value = mrYes then
          begin

              // set sidebar element active style
              el := document.getElementById('leitura1');

              //Coloca Identificador da Tabela na variável global
              if el['value'] <> '' then
              begin
                  Zap_API_Data(StrToInt(el['value'])); //Pesquisa Itens da Data
              end;

              Result := true;
              Event.preventDefault;
              Event.stopPropagation;

          end;

    end;

begin
  Msg01.ShowDialog('Deseja excluir a data selecionada ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

function TLoadTXT.HandleZap2Click(Event: TJSMouseEvent): Boolean;

    procedure Afterdialog(Value: TModalResult);
    var
      el: TJSElement;
    begin

          if Value = mrYes then
          begin

              // set sidebar element active style
              el := document.getElementById('leitura2');

              //Coloca Identificador da Tabela na variável global
              if el['value'] <> '' then
              begin
                  Zap_API_Data(StrToInt(el['value'])); //Pesquisa Itens da Data
              end;

              Result := true;
              Event.preventDefault;
              Event.stopPropagation;

          end;

    end;

begin
  Msg01.ShowDialog('Deseja excluir a data selecionada ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

function TLoadTXT.HandleZap3Click(Event: TJSMouseEvent): Boolean;

    procedure Afterdialog(Value: TModalResult);
    var
      el: TJSElement;
    begin

          if Value = mrYes then
          begin

              // set sidebar element active style
              el := document.getElementById('leitura3');

              //Coloca Identificador da Tabela na variável global
              if el['value'] <> '' then
              begin
                  Zap_API_Data(StrToInt(el['value'])); //Pesquisa Itens da Data
              end;

              Result := true;
              Event.preventDefault;
              Event.stopPropagation;

          end;

    end;

begin
  Msg01.ShowDialog('Deseja excluir a data selecionada ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

function TLoadTXT.HandleZap4Click(Event: TJSMouseEvent): Boolean;

    procedure Afterdialog(Value: TModalResult);
    var
      el: TJSElement;
    begin

          if Value = mrYes then
          begin

              // set sidebar element active style
              el := document.getElementById('leitura4');

              //Coloca Identificador da Tabela na variável global
              if el['value'] <> '' then
              begin
                  Zap_API_Data(StrToInt(el['value'])); //Pesquisa Itens da Data
              end;

              Result := true;
              Event.preventDefault;
              Event.stopPropagation;

          end;

    end;

begin
  Msg01.ShowDialog('Deseja excluir a data selecionada ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;


function TLoadTXT.HandleZap5Click(Event: TJSMouseEvent): Boolean;

    procedure Afterdialog(Value: TModalResult);
    var
      el: TJSElement;
    begin

          if Value = mrYes then
          begin

              // set sidebar element active style
              el := document.getElementById('leitura5');

              //Coloca Identificador da Tabela na variável global
              if el['value'] <> '' then
              begin
                  Zap_API_Data(StrToInt(el['value'])); //Pesquisa Itens da Data
              end;

              Result := true;
              Event.preventDefault;
              Event.stopPropagation;

          end;

    end;

begin
  Msg01.ShowDialog('Deseja excluir a data selecionada ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;


procedure TLoadTXT.IdCardDblClick(Sender: TObject);
begin
    nRESP.Visible:= not nRESP.Visible;
end;

procedure TLoadTXT.Load_API_Datas;
var
  xURL, Criterio: string;
begin
//B- Pesquisa as Datas
      cItens:= 0;     //Contador dos itens
      qCards:= 4;     //Etiquetas por Linha

      xURL:= '';
      Criterio:= '';

      try
        Datas_Con.Active:= false;

        //BaseURL := 'produtos?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);
        xURL := FrmMain.BaseURL + 'carga?offset=0&fetch=6&iduser=47&qtdesaldo%3E0';
        //http://localhost:8083/api/carga?offset=0&fetch=10&iduser=47&qtdesaldo%3E0

        //MousePointer.Cursor := -11;
        if Criterio = '' then
        begin
          //UTF8Encode(BaseURL);
          Datas_Con.URI := xURL;
        end else begin

          //Datas_Con.URI := BaseURL+'&'+xCampo+'='+Interm;
          Datas_Con.URI := xURL;
          // ' = %27
          // % = %25;
          // % = &#37;
          //produtos?offset=0&fetch=100&gestao=0
        end;
        Datas_Con.Active:= true;
      finally
        //Screen.Cursor := 0;
      end;
//B- Pesquisa as Datas
end;

procedure TLoadTXT.Zap_API_Data(Id: Integer);
begin

      //End Point de Exclusão da Data
      //http://localhost:8082/api/carga/zap_carga
      {
          "idudv": 88277      //IdRec a ser excluído
      }
      try
          execAPIs.URL := FrmMain.BaseURL + 'carga/zap_carga';
          execAPIs.Command := httpPOST;
          execAPIs.Headers.Clear;
          execAPIs.Headers.AddPair('Content-Type','application/json');
          execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
          execAPIs.PostData :=
          '{"idudv": "' + IntToStr(Id) + '"}'; //Identificador da Data na Tabela ItensNF_Volumes
          execAPIs.Execute();
      except on E: Exception do
        begin
           showmessage('O seguinte erro ocorreu ao excluir a data! : '+E.Message);
        end;
      end;

      //Refresh nas Datas
      Load_API_Datas;  //???????? porque não funciona

end;

procedure TLoadTXT.Load_API_UDs(Id: Integer);
var
  xURL, Criterio: string;
begin
//B- Pesquisa as Datas
      cItens:= 0;     //Contador dos itens
      qCards:= 4;     //Etiquetas por Linha

      xURL:= '';
      Criterio:= '';

      try
        Datas_Con.Active:= false;

        //BaseURL := 'produtos?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina);
        xURL := FrmMain.BaseURL + 'produtos/prod_gcards?idudv='+IntToStr(Id);
        //http://localhost:8083/api/produtos?prod_cards=8
        nRESP.Lines.Add(xURL);

        //MousePointer.Cursor := -11;
        if Criterio = '' then
        begin
          //UTF8Encode(BaseURL);
          UDs_Con.URI := xURL;
        end else begin

          //UDs_Con.URI := BaseURL+'&'+xCampo+'='+Interm;
          UDs_Con.URI := xURL;
          // ' = %27
          // % = %25;
          // % = &#37;
          //produtos?offset=0&fetch=100&gestao=0
        end;
        UDs_Con.Active:= true;
      finally
        //Screen.Cursor := 0;
      end;
//B- Pesquisa as Datas
end;

procedure TLoadTXT.UDs_ConAfterConnect(Sender: TObject);
begin
    //0- Carregar Tabela de Datas
    LoadTable_UDS;  //Ler a Tabela primeiramente
end;

procedure TLoadTXT.LoadFile;
var
  ext: string;
begin
  if Assigned(btnLoadFILE.Files[0]) then
  begin
    fl := True;
    btnLoadFILE.Files[0].GetFileAsText;
    FFileName := btnLoadFILE.Files[0].Name;
    ext := ExtractFileExt(FFileName);
    //SetSyntaxMemoMode(ext);
  end;
end;

procedure TLoadTXT.LoadTable_Datas;
var
  i: integer;
  xHeader, xItens: string;

  evis, ezap: TJSHTMLElement;
begin
    divTabela.HTML.Clear;
    divTabela.HTML.Add('<div id="loader" class="loader"></div>');
    //divTabela.HTML.Add('<h3>Itens não encontrados para a data (' + el['value'] + ') !</h3>');
    xHeader:=   //Header de Table
    '<table>'+
        '<thead>'+
            '<tr>'+
                '<th>#</th>'+
                '<th>Data da Leitura</th>'+
                '<th>Qtde Total</th>'+
                //'<th>Situação</th>'+
                '<th>Ações</th>'+
            '</tr>'+
        '</thead>'+
      '<tbody>';

    cItens:= 0;
    xItens:= '';
    vItens:= '';
    repeat
        //Cards
        xItens:= xItens +
        '<tr>'+
          '<td data-name="Nº Leitura" id="leitura' + IntToStr(cItens) + '" value="' + Datas_DSET.FieldByName('idudv').AsString + '">' + Datas_DSET.FieldByName('idudv').AsString + '</td>'+
          '<td data-name="Data Leitura">' + FormatDateTime('dd/mm/yyyy hh:mm', Datas_DSET.FieldByName('DataMvto').AsDateTime) + '</td>'+
          '<td data-name="Qtde">' + Datas_DSET.FieldByName('qtdeud').AsString + '</td>'+


					'<td><button type="button" class="btn btn-warning btn-sm" id="edit' + IntToStr(cItens) + '" ><i class="fa fa-edit"></i></button>'+
					'<button type="button" class="btn btn-danger btn-sm" id="zap' + IntToStr(cItens) + '" style="margin-left: 1px;"><i class="fa fa-trash"></i></button>'+ '</td>'+
          //'<td><button type="button" class="btn btn-warning btn-sm" id="edit" onclick="myBtnClick()" onclick="javascript:alert(' + #39 + 'Número do Identificador: ' + Datas_DSET.FieldByName('idudv').AsString + #39 + ')"><i class="fa fa-edit"></i></button>'+

					//'<button type="button" class="btn btn-danger btn-xs" id="delete"><i class="fa fa-trash" onclick="Act_delete(xxx)"></i></button></td>'+

        '</tr>';

// ************** Código de Barras **************
//        //Vefifica se é 0 começo da linha (8 mod 4 = 0), verificar antes de somar
//        if cItens MOD qCards = 0 then
//        begin
//           vItens:= vItens + '<div class="row">';
//        end;
//
//        vItens:= vItens +
//        '<div class="col-sm">'+
//        '<section class="card contact">'+
//        '<img id="barcode' + IntToStr(i) + '"/>'+
//        '<script>JsBarcode("#barcode' + IntToStr(i) + '", "' + Datas_DSET.FieldByName('idudv').AsString + '", {height: 50});</script>'+
//        '<span>' + FormatDateTime('dd/mm/yyyy hh:mm', Datas_DSET.FieldByName('DataMvto').AsDateTime) + '</span>'+
//        '<span>' + Datas_DSET.FieldByName('qtdeud').AsString + '</span>'+
//        '</section>'+
//        '</div>';
// ************** Código de Barras **************

        inc(cItens); //Incrementa Itens para poder variar o código de barras

        //Vefifica se é 0 começo da linha (8 mod 4 = 0), verificar no último campo
        // Não precisa da instrução { and (cItens <> 0 )} pois somou acima
        if cItens MOD qCards = 0 then
        begin
           vItens:= vItens + '</div>';
        end;

        Datas_DSET.Next;

    until(Datas_DSET.Eof);

    //Transfere Dados para Div "Table"
    divTabela.HTML.Clear;
    divTabela.HTML.Add(xHeader + xItens + '</tbody>');

    //Perfeito adicionar eventos aos botões INSERIDOS dinamicamente no HTML
    for i := 0 to Datas_DSET.RecordCount-1 do
    begin
        //Adicionar Eventos (Somente após a leitura da Tabela somente para os existentes baseado no contador)
        evis := TJSHTMLElement(document.getElementById('edit'+IntToStr(i)));
        ezap := TJSHTMLElement(document.getElementById('zap'+IntToStr(i)));
        case i of
          0:begin
              evis.addEventListener('click', @HandleEdit0Click);    //Evento de pesquisa das UDs de uma data somadas por Produto
              ezap.addEventListener('click', @HandleZap0Click);     //Evento de exclusão de uma data (somente desvincula as UDs da Data sem exclusão)
          end;
          1:begin
              evis.addEventListener('click', @HandleEdit1Click);
              ezap.addEventListener('click', @HandleZap1Click);
          end;
          2:begin
              evis.addEventListener('click', @HandleEdit2Click);
              ezap.addEventListener('click', @HandleZap2Click);
          end;
          3:begin
              evis.addEventListener('click', @HandleEdit3Click);
              ezap.addEventListener('click', @HandleZap3Click);
          end;
          4:begin
              evis.addEventListener('click', @HandleEdit4Click);
              ezap.addEventListener('click', @HandleZap4Click);
          end;
          5:begin
              evis.addEventListener('click', @HandleEdit5Click);
              ezap.addEventListener('click', @HandleZap5Click);
          end;
        end;

    end;

end;

procedure TLoadTXT.LoadTable_UDS;
var
  i: integer;
  xHeader, xItens: string;
begin
    //divTabelaEtqs.HTML.Add('<h3>Itens não encontrados para a data (' + el['value'] + ') !</h3>');
    xHeader:=   //Header de Table
    '<table>'+
        '<thead>'+
            '<tr>'+
                '<th>#</th>'+
                '<th>Produto</th>'+
                '<th>Qtde</th>'+
                '<th>Descrição do Produto</th>'+
            '</tr>'+
        '</thead>'+
      '<tbody>';

    cItens:= 0;
    xItens:= '';
    vItens:= '';
    repeat
        inc(cItens); //Incrementa Itens
        //Linhas
        xItens:= xItens +
        '<tr>'+
          '<td>' + IntToStr(cItens) + '</td>'+
          '<td>' + UDs_DSET.FieldByName('produto').AsString + '</td>'+
          '<td>' + UDs_DSET.FieldByName('idud').AsString + '</td>'+
          '<td>' + UDs_DSET.FieldByName('descr').AsString + '</td>'+

        '</tr>';

        UDs_DSET.Next;

    until(UDs_DSET.Eof);

    divTabelaEtqs.HTML.Clear;
    divTabelaEtqs.HTML.Add(xHeader + xItens + '</tbody>');

end;

procedure TLoadTXT.loadTXTChange(Sender: TObject);
begin
    btnLoadFILEChange(Self);
end;

procedure TLoadTXT.Datas_ConAfterConnect(Sender: TObject);
begin
    //0- Carregar Tabela de Datas
    xIdUdV:= 0;       //Zera Identificador
    LoadTable_Datas;  //Ler a Tabela primeiramente
end;

procedure TLoadTXT.WebFormShow(Sender: TObject);
begin
    Load_API_Datas;
end;

procedure TLoadTXT.btnLoadFILEChange(Sender: TObject);
begin
    //nCont.Caption := '';
    nRESP.Text    := '';
    //nARQ.Text   := '';
    //nRESP.Text    := '';

    LoadFile;
end;

procedure TLoadTXT.btnLoadFILEGetFileAsText(Sender: TObject;
  AFileIndex: Integer; AText: string);
begin
    //WebSyntaxMemo1.Text := AText;
    nARQ.Text := AText;
end;

procedure TLoadTXT.btnPROCClick(Sender: TObject);
var
  OKArqProd: boolean;
  zLinhas, zCont, zContPROD, zCampos, xFDstart, xFDend, xStart, xEnd: integer;
  xProd, xProdOLD, xIdProd, xDesenho, xDESCR, xURL: string;

  //Seção do TWebHttpRequest sem componente visual 30/05/2025
  WebRequest: THttpRequest;
  Submission: TJSXMLHttpRequest;
  SubmissionResponse: String;
  //PAS_Object: TJSONObject;
begin
    if nARQ.Lines.Count = 0 then
    begin
      ShowMessage('Não existe dados para o processamento !');
      exit;
    end;

    //Limpa e coloca a ampulheta
    divTabela.HTML.Clear;
    divTabela.HTML.Add('<div id="loader" class="loader"></div>');

    divTabelaEtqs.HTML.Clear;   //Somente Limpa

    //Cria componente
    //https://support.tmssoftware.com/t/looking-for-code-example-for-twebhttprequest-post-to-upload-a-file/21267
    WebRequest := THTTPRequest.Create(nil);

    nRESP.Lines.Clear;   //Limpa memorando da guarda de dados

//A- Cadastra o volume para determinar as datas
    //WebHttpRequest1.URL := 'data.json';
    WebRequest.URL := FrmMain.BaseURL + 'carga/nova_carga';
    WebRequest.Command := httpPOST;
    WebRequest.TimeOut := 5000;
    WebRequest.Headers.Clear;
    WebRequest.Headers.AddPair('Content-Type','application/json');
    WebRequest.Headers.AddPair('Accept','application/json, text/plain, */*');
    WebRequest.PostData := '{'
    + '"iduser": 47, '
    + '"idpess": "0"'     //606- Cria data do dia 0- Crias o dia e a hora
    + '}';

    try
      Submission := await(TJSXMLHttpRequest, WebRequest.Perform());
      SubmissionResponse := string(Submission.response);

      nRESP.Lines.Add(SubmissionResponse);  //Guarda erro se houver

      xStart := 0;  xStart:= pos('"idudv":', SubmissionResponse);    //Verifica o início do IdProd (Descontar 8 posições)
      xEnd   := 0;  xEnd:= pos(',"iduser":', SubmissionResponse);   //Verifica o final do IdProd

      //Extrair o xIdUdV do JSON retornado (Certeza que exuste somente um registro)
      xIdUdV:= 0;
      if (xStart > 0) and (xEnd > xStart) then
      begin
          xIdUdV:= StrToInt(Copy(SubmissionResponse, xStart+8, xEnd - (xStart+8)));
      end;

    except on E: Exception do
      begin
         //console.log('Submission Error: '+E.Message);
         nRESP.Lines.Add('Submission Error: '+E.Message);  //Guarda erro se houver
      end;
    end;

//A- Cadastra o volume para determinar as datas


    FrmMain.loader.Visible    := true; //Ampulheta da WEB

    //A- Verifica se o arquivo é de Produtos e tem os dados corretamente-90
    OKArqProd   := true;
    for zLinhas := 0 to nARQ.Lines.Count-1 do
    begin

        //Se envontrar '^MCY' então não é etiqueta de Produtos
        if pos('^MCY', nARQ.Lines[zLinhas]) > 0 then
        begin
            OKArqProd   := false;
        end;

    end;


    xProdOLD:= '';

    zLinhas   := 0;
    zContPROD := 0;
    for zLinhas := 0 to nARQ.Lines.Count-1 do
    begin

        //Se envontrar '^MCY' então não é etiqueta de Produtos
        //Blocos de Produtos
        if pos('^MCY', nARQ.Lines[zLinhas]) > 0 then
        begin
            //nRESP.Lines.Add('Este é um arquivo de volume e não de Produtos !');
            MessageDlg('Este é um arquivo de volume e não de Produtos !', mtError, [mbOK]);
            //MessageDlg('Usuário e senha são exigidos !', mtError, []);
            exit;
        end;

        //Blocos de Produtos
        if pos('CI28', nARQ.Lines[zLinhas]) > 0 then
        begin
            inc(zCont);   //Contador de Produto
            //nCont.Caption:= htmARQ.Lines[zLinhas];
            zCampos:= 0;

            xDesenho  := '';
            xProd     := '';
            xDesenho  := '';
            xDESCR    := '';
        end;

        //Campos de Produtos
        xFDstart:= pos('^FD', nARQ.Lines[zLinhas]);
        if xFDstart > 0 then
        begin
            inc(zCampos);   //Inclusão de campos

            //nCont.Caption:= htmARQ.Lines[zLinhas];
            xFDend:= 0;
            xFDend:= pos('^FS', nARQ.Lines[zLinhas]);
            if xFDend > 0 then
            begin
            //Está na mesma linha

              if xFDend >= xFDstart then
              begin

                  if xFDend > 0 then
                  begin
                      case zCampos of
                        1: begin
                        //Produto
                            inc(zContPROD);
                            xProd:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                        4: begin
                        //Descrição
                            xDESCR:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                        7: begin
                        //Desenho
                            xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, xFDend - xFDstart - 3);
                        end;
                      end;
                  end else begin
                  //Desenho (Não tem ^Fs no final)
                      if zCampos = 7 then
                      begin
                          xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, 100);
                      end;
                  end;
              end;

            end else begin
            //Não está na mesma linha
                //Desenho (Não tem ^Fs no final)
                xDesenho:= Copy(nARQ.Lines[zLinhas], xFDstart + 3, 100);
            end;

            if zCampos = 7 then
            begin

                if xProdOLD <> xProd then
                begin
                    xProdOLD  := xProd;
                    zContPROD := 1;
                end;


                //01- Cadastra os Produtos
                //try
                      WebRequest.URL := FrmMain.BaseURL + 'produtos/novo_produto';
                      WebRequest.Command := httpPOST;
                      WebRequest.TimeOut := 5000;
                      WebRequest.Headers.Clear;
                      WebRequest.Headers.AddPair('Content-Type','application/json');
                      WebRequest.Headers.AddPair('Accept','application/json, text/plain, */*');
                      WebRequest.PostData := '{'
                      + '"produto": "' + xProd + '", '
                      + '"desenho": "' + xDesenho + '", '
                      + '"descr": "' + xDESCR + '", '
                      + '"und": "Und", '
                      + '"iduser": 47 '
                      + '}';
                      nRESP.Lines.Add(WebRequest.PostData);
                      //WebRequest.Execute(); Abaixo será executado

                      try
                          Submission := await(TJSXMLHttpRequest, WebRequest.Perform()); //Executa e guarda a resposta
                          SubmissionResponse := string(Submission.response);
                          xStart := 0;  xStart:= pos('"idprod":', SubmissionResponse);    //Verifica o início do IdProd (Descontar 9 posições)
                          xEnd   := 0;  xEnd:= pos(',"produto":', SubmissionResponse);   //Verifica o final do IdProd

                          //Extrair o IdProd do JSON retornado (Certeza que exuste somente um registro)
                          xIdProd:= '0';
                          if (xStart > 0) and (xEnd > xStart) then
                          begin
                              xIdProd:= Copy(SubmissionResponse, xStart+9, xEnd - (xStart+9));
                              //nRESP.Lines.Add('IdProduto: ' + xIdProd);
                          end;

                          //Esta função abaixo não funcionou (talvez devido ao "data")
                          //PAS_Object := TJSONObject.ParseJSONValue(SubmissionResponse) as TJSONObject;
                          //nRESP.Lines.Add('IdProduto: '+(PAS_Object.getValue('idprod') as TJSONString).Value);   ///Guarda dados para avaliação
                      except on E: Exception do
                          begin
                             //console.log('Submission Error: '+E.Message);
                             nRESP.Lines.Add('Submission Error: '+E.Message);  //Guarda erro se houver
                          end;
                      end;

                      if xIdProd <> '0' then
                      begin
                      //03- Cadastra a etiqueta na data selecionada (Se IdProd <> 0 )
                          execAPIs.URL := FrmMain.BaseURL + 'itensnfuds/nova_ud';
                          execAPIs.Command := httpPOST;
                          execAPIs.Headers.Clear;
                          execAPIs.Headers.AddPair('Content-Type','application/json');
                          execAPIs.Headers.AddPair('Accept','application/json, text/plain, */*');
                          execAPIs.PostData :=
                          '{"idprod": "' + xIdProd + '", '+               //Identificador do Produto
                          '"idudv": "' + IntToStr(xIdUdV) + '", '+   //Identificador da Data na Tabela ItensNF_Volumes
                          '"qtdeud": "1", '+                              //Quantidade de Produtos (Neste caso é fixo)
                          '"iduser": "47"}';                              //Identificador do Usuário
                          execAPIs.Execute();
                      end;




            end;

        end;

    end;

    FrmMain.loader.Visible    := false; //Ampulheta da WEB

//B- Pesquisa as Datas
            Load_API_Datas;
            //LoadTable_Datas;
//B- Pesquisa as Datas

    nArq.Text:= '';
    ShowMessage('Arquivo processado com sucesso !');

end;

procedure TLoadTXT.btnImprimirClick(Sender: TObject);

    procedure Afterdialog(Value: TModalResult);
    var
    xInicio, xCards, xFim: string;
    begin

          if Value = mrYes then
          begin

              if xIdUdV = 0 then
              begin
                  ShowMessage('Selecione ao menos uma data !');
                  exit;
              end else begin
              //**** Cria Form a assinala em FrmMain.HostPanel.ElementID
                  FrmMain.xIdUdV:= xIdUdV;  //Usa FrmMain.xIdUdV como variável Global

                  // destroy possible old form
                  if Assigned(frm) then
                    frm.Close;

                  frm :=  TCards.CreateNew(FrmMain.HostPanel.ElementID, nil);
              //**** Cria Form a assinala em FrmMain.HostPanel.ElementID
              end;


//              //****** Rotina antiga de impressão direta ********
//              //Cabeçalho do HTML
//              xInicio:= '<html lang="en">'+
//              '<head>'+
//                '<meta charset="UTF-8">'+
//                '<meta name="viewport" content="width=device-width, initial-scale=1.0">'+
//                '<meta http-equiv="X-UA-Compatible" content="IE=edge">'+
//                '<title>Responsive Cards page A4 Report</title>'+
//                '<link href="https://fonts.googleapis.com/css?family=Varela+Round" rel="stylesheet" />'+
//                '<link rel="stylesheet" href="style.css">'+
//                '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">'+
//                '<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" '+
//                'integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">'+
//
//                //Barcode
//                '<script src="assets/dist/JsBarcode.all.js"></script>'+
//                '<script>'+
//                  'Number.prototype.zeroPadding = function(){'+
//                    'var ret = "" + this.valueOf();'+
//                    'return ret.length == 1 ? "0" + ret : ret;'+
//                  '};'+
//                '</script>'+
//              '</head>'+
//              '<body onload="window.print()">'+
//              //'<div class="col-12 text-center my-4">';
//              '<div class="container">';
//
//              xCards:= vItens;
//
//              //Final do HTML
//              xFim:= '</div></body></html>';
//
//              //Html completo para testes (Deixar ativo e copiar após a impressão para testes)
//              //htmTeste.Text:= xInicio + vItens + xFim;
//
//              //Complementar as últimas etiquetas devido o posicionamento das mesmas
//
//              //Javascript
//              asm
//
//               //var divToPrint = document.getElementsByClassName('header_table')[0];
//               var anotherWindow = window.open('', 'Print-Window');
//               anotherWindow.document.open();
//               anotherWindow.document.write(
//               xInicio +
//
//
//               xCards +
//
//
//               xFim);
//               anotherWindow.document.close();
//
//              end;
//              //****** Rotina antiga de impressão direta ********

          end;

    end;


begin
  if xIdUdV = 0 then
  begin
      ShowMessage('Selecione ao menos uma data !');
      exit;
  end;

  Msg01.ShowDialog('Deseja visualizar as etiquetas ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

procedure TLoadTXT.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divTabela := THTMLDiv.Create('Table');
  btnImprimir := TButton.Create('imprimir');
  Msg01 := TMessageDlg.Create(Self);
  btnPROC := TButton.Create('idprocessar');
  btnLoadFILE := TFilePicker.Create('xArq');
  nRESP := TMemo.Create(Self);
  nArq := TMemo.Create('nArq');
  divTabelaEtqs := THTMLDiv.Create('Table_etqs');
  Datas_Con := TClientConnection.Create(Self);
  Datas_DSET := TClientDataSet.Create(Self);
  Cargas_idudv := TIntegerField.Create(Self);
  Cargas_DataMvto := TDateTimeField.Create(Self);
  Cargas_QtdeUD := TIntegerField.Create(Self);
  execAPIs := THttpRequest.Create(Self);
  UDs_Con := TClientConnection.Create(Self);
  UDs_DSET := TClientDataSet.Create(Self);
  UDs_IdProd := TIntegerField.Create(Self);
  UDs_produto := TStringField.Create(Self);
  UDs_Descr := TStringField.Create(Self);
  UDs_IdUd := TIntegerField.Create(Self);

  divTabela.BeforeLoadDFMValues;
  btnImprimir.BeforeLoadDFMValues;
  Msg01.BeforeLoadDFMValues;
  btnPROC.BeforeLoadDFMValues;
  btnLoadFILE.BeforeLoadDFMValues;
  nRESP.BeforeLoadDFMValues;
  nArq.BeforeLoadDFMValues;
  divTabelaEtqs.BeforeLoadDFMValues;
  Datas_Con.BeforeLoadDFMValues;
  Datas_DSET.BeforeLoadDFMValues;
  Cargas_idudv.BeforeLoadDFMValues;
  Cargas_DataMvto.BeforeLoadDFMValues;
  Cargas_QtdeUD.BeforeLoadDFMValues;
  execAPIs.BeforeLoadDFMValues;
  UDs_Con.BeforeLoadDFMValues;
  UDs_DSET.BeforeLoadDFMValues;
  UDs_IdProd.BeforeLoadDFMValues;
  UDs_produto.BeforeLoadDFMValues;
  UDs_Descr.BeforeLoadDFMValues;
  UDs_IdUd.BeforeLoadDFMValues;
  try
    Name := 'LoadTXT';
    Width := 1000;
    Height := 848;
    Caption := 'Produtos_Con';
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    FormContainer := 'appcontent';
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divTabela.SetParentComponent(Self);
    divTabela.Name := 'divTabela';
    divTabela.Left := 139;
    divTabela.Top := 8;
    divTabela.Width := 100;
    divTabela.Height := 22;
    divTabela.ChildOrder := 2;
    divTabela.Role := '';
    btnImprimir.SetParentComponent(Self);
    btnImprimir.Name := 'btnImprimir';
    btnImprimir.Left := 37;
    btnImprimir.Top := 8;
    btnImprimir.Width := 96;
    btnImprimir.Height := 25;
    btnImprimir.Caption := 'Visualizar';
    btnImprimir.ChildOrder := 2;
    btnImprimir.HeightPercent := 100.000000000000000000;
    btnImprimir.WidthPercent := 100.000000000000000000;
    SetEvent(btnImprimir, Self, 'OnClick', 'btnImprimirClick');
    Msg01.SetParentComponent(Self);
    Msg01.Name := 'Msg01';
    Msg01.Left := 572;
    Msg01.Top := 192;
    Msg01.Width := 24;
    Msg01.Height := 24;
    Msg01.Buttons := [];
    Msg01.Opacity := 0.200000000000000000;
    btnPROC.SetParentComponent(Self);
    btnPROC.Name := 'btnPROC';
    btnPROC.Left := 37;
    btnPROC.Top := 39;
    btnPROC.Width := 96;
    btnPROC.Height := 25;
    btnPROC.Caption := 'Processar';
    btnPROC.ChildOrder := 5;
    btnPROC.HeightPercent := 100.000000000000000000;
    btnPROC.WidthPercent := 100.000000000000000000;
    SetEvent(btnPROC, Self, 'OnClick', 'btnPROCClick');
    btnLoadFILE.SetParentComponent(Self);
    btnLoadFILE.Name := 'btnLoadFILE';
    btnLoadFILE.Left := 139;
    btnLoadFILE.Top := 64;
    btnLoadFILE.Width := 100;
    btnLoadFILE.Height := 22;
    btnLoadFILE.ChildOrder := 6;
    SetEvent(btnLoadFILE, Self, 'OnChange', 'btnLoadFILEChange');
    SetEvent(btnLoadFILE, Self, 'OnGetFileAsText', 'btnLoadFILEGetFileAsText');
    nRESP.SetParentComponent(Self);
    nRESP.Name := 'nRESP';
    nRESP.Left := 24;
    nRESP.Top := 134;
    nRESP.Width := 729;
    nRESP.Height := 219;
    nRESP.ElementClassName := 'form-control';
    nRESP.ElementFont := efCSS;
    nRESP.Font.Charset := ANSI_CHARSET;
    nRESP.Font.Color := clWindowText;
    nRESP.Font.Height := -13;
    nRESP.Font.Name := 'Open Sans';
    nRESP.Font.Style := [];
    nRESP.HeightStyle := ssPercent;
    nRESP.HeightPercent := 92.000000000000000000;
    nRESP.Lines.BeginUpdate;
    try
      nRESP.Lines.Clear;
      nRESP.Lines.Add('1- Gerar Datas a partir da escolha do cadastro de Produtos');
      nRESP.Lines.Add('2- 10 x 15 etiqueta nova com layout 50%');
      nRESP.Lines.Add('3- JWT com Senha');
    finally
      nRESP.Lines.EndUpdate;
    end;
    nRESP.ParentFont := False;
    nRESP.ReadOnly := True;
    nRESP.SelLength := 0;
    nRESP.SelStart := 119;
    nRESP.Visible := False;
    nRESP.WidthPercent := 98.000000000000000000;
    nArq.SetParentComponent(Self);
    nArq.Name := 'nArq';
    nArq.Left := 24;
    nArq.Top := 384;
    nArq.Width := 729;
    nArq.Height := 89;
    nArq.ElementFont := efCSS;
    nArq.ElementPosition := epIgnore;
    nArq.HeightStyle := ssAuto;
    nArq.HeightPercent := 100.000000000000000000;
    nArq.ReadOnly := True;
    nArq.SelLength := 0;
    nArq.SelStart := 0;
    nArq.WidthStyle := ssAuto;
    nArq.WidthPercent := 100.000000000000000000;
    divTabelaEtqs.SetParentComponent(Self);
    divTabelaEtqs.Name := 'divTabelaEtqs';
    divTabelaEtqs.Left := 139;
    divTabelaEtqs.Top := 36;
    divTabelaEtqs.Width := 100;
    divTabelaEtqs.Height := 22;
    divTabelaEtqs.ChildOrder := 2;
    divTabelaEtqs.Role := '';
    Datas_Con.SetParentComponent(Self);
    Datas_Con.Name := 'Datas_Con';
    Datas_Con.Active := False;
    Datas_Con.DataNode := 'data';
    Datas_Con.Delimiter := ';';
    Datas_Con.AfterConnect := Datas_ConAfterConnect;
    Datas_Con.Left := 560;
    Datas_Con.Top := 8;
    Datas_DSET.SetParentComponent(Self);
    Datas_DSET.Name := 'Datas_DSET';
    Datas_DSET.Connection := Datas_Con;
    Datas_DSET.Left := 560;
    Datas_DSET.Top := 64;
    Cargas_idudv.SetParentComponent(Datas_DSET);
    Cargas_idudv.Name := 'Cargas_idudv';
    Cargas_idudv.FieldName := 'idudv';
    Cargas_DataMvto.SetParentComponent(Datas_DSET);
    Cargas_DataMvto.Name := 'Cargas_DataMvto';
    Cargas_DataMvto.FieldName := 'datamvto';
    Cargas_QtdeUD.SetParentComponent(Datas_DSET);
    Cargas_QtdeUD.Name := 'Cargas_QtdeUD';
    Cargas_QtdeUD.FieldName := 'qtdeud';
    execAPIs.SetParentComponent(Self);
    execAPIs.Name := 'execAPIs';
    execAPIs.Left := 563;
    execAPIs.Top := 121;
    UDs_Con.SetParentComponent(Self);
    UDs_Con.Name := 'UDs_Con';
    UDs_Con.Active := False;
    UDs_Con.DataNode := 'data';
    UDs_Con.Delimiter := ';';
    UDs_Con.AfterConnect := UDs_ConAfterConnect;
    UDs_Con.Left := 648;
    UDs_Con.Top := 8;
    UDs_DSET.SetParentComponent(Self);
    UDs_DSET.Name := 'UDs_DSET';
    UDs_DSET.Connection := UDs_Con;
    UDs_DSET.Left := 648;
    UDs_DSET.Top := 64;
    UDs_IdProd.SetParentComponent(UDs_DSET);
    UDs_IdProd.Name := 'UDs_IdProd';
    UDs_IdProd.FieldName := 'idprod';
    UDs_produto.SetParentComponent(UDs_DSET);
    UDs_produto.Name := 'UDs_produto';
    UDs_produto.FieldName := 'produto';
    UDs_produto.Size := 30;
    UDs_Descr.SetParentComponent(UDs_DSET);
    UDs_Descr.Name := 'UDs_Descr';
    UDs_Descr.FieldName := 'descr';
    UDs_Descr.Size := 100;
    UDs_IdUd.SetParentComponent(UDs_DSET);
    UDs_IdUd.Name := 'UDs_IdUd';
    UDs_IdUd.FieldName := 'idud';
  finally
    divTabela.AfterLoadDFMValues;
    btnImprimir.AfterLoadDFMValues;
    Msg01.AfterLoadDFMValues;
    btnPROC.AfterLoadDFMValues;
    btnLoadFILE.AfterLoadDFMValues;
    nRESP.AfterLoadDFMValues;
    nArq.AfterLoadDFMValues;
    divTabelaEtqs.AfterLoadDFMValues;
    Datas_Con.AfterLoadDFMValues;
    Datas_DSET.AfterLoadDFMValues;
    Cargas_idudv.AfterLoadDFMValues;
    Cargas_DataMvto.AfterLoadDFMValues;
    Cargas_QtdeUD.AfterLoadDFMValues;
    execAPIs.AfterLoadDFMValues;
    UDs_Con.AfterLoadDFMValues;
    UDs_DSET.AfterLoadDFMValues;
    UDs_IdProd.AfterLoadDFMValues;
    UDs_produto.AfterLoadDFMValues;
    UDs_Descr.AfterLoadDFMValues;
    UDs_IdUd.AfterLoadDFMValues;
  end;
end;

end.
